import { useEffect } from 'react';

type PropTypes = {
  selector: string | null;
  isReady: boolean;
};

export const useScrollToElement = ({ selector, isReady }: PropTypes) => {
  useEffect(() => {
    if (selector && isReady) {
      const timer = setTimeout(() => {
        const element = document.querySelector(selector);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [selector, isReady]);
};
